export default {
      id: "command__history-usage",
      viewBox: "0 0 144 105",
      url: __webpack_public_path__ + "img/icons.svg#command__history",
      toString: function () {
        return this.url;
      }
    }